import { Spinner, Space } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import type { PropsWithChildren } from 'react';

import { OfferButton } from '../OfferButton/OfferButton';

export const Pending = ({ children, ...props }: PropsWithChildren<ButtonProps>) => (
  <OfferButton
    {...props}
    variant="primary"
    color="dark"
    disabled
  >
    <Space
      direction="row"
      size={8}
    >
      {children}
      <Spinner />
    </Space>
  </OfferButton>
);
